import styled from 'styled-components';

export const StyledIsOpenWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
